import ISwishService from './ISwishService';
import { AxiosResponse } from 'axios';
import i18n from '@apps/Shared/translation/i18n';
import {
    SwishActivatePaymentBody,
    SwishApplyBody,
    SwishCertificateCsrBody,
    SwishCertificateUploadBody,
    SwishPayerCertificateInfoResponse
} from './types';
import { clearServerMessage, renderServerMessage } from '@apps/Shared/Utils/ServerMessage';
import { Client } from '@apps/Shared/Services/Axios';
import { ENDPOINT } from '@apps/Shared/Services/Axios/Api';

class SwishService implements ISwishService {
    async Apply(postBody: SwishApplyBody) {
        let res: AxiosResponse;

        try {
            res = await Client('post', `${ENDPOINT.Swish.Apply()}`, postBody);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async GetCustomerInfo(orgNumber: string) {
        let res: AxiosResponse;

        try {
            res = await Client('get', `${ENDPOINT.Swish.CustomerInfo(orgNumber)}`);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async GetCustomerEligibility(orgNumber: string) {
        let res: AxiosResponse;

        try {
            res = await Client('get', `${ENDPOINT.Swish.CustomerEligibility(encodeURIComponent(orgNumber))}`);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async GetEligibleCustomerSites() {
        let res: AxiosResponse;

        try {
            res = await Client('get', `${ENDPOINT.Owner.EligibleCustomerSites()}`);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async ActivateSwishPayment(postBody: SwishActivatePaymentBody) {
        let res: AxiosResponse;

        try {
            res = await Client('post', `${ENDPOINT.Owner.ActivateSwishPayment()}`, postBody);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async GetCertificateInfo() {
        let res: AxiosResponse<SwishPayerCertificateInfoResponse>;

        try {
            res = await Client('get', `${ENDPOINT.Swish.CertificateInfo()}`);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            if (error.response?.status !== 404) {
                renderServerMessage('error', i18n.t('error.disruptions'));
            }
            return error.response;
        }

        if (typeof res.data === 'string') {
            res.data = JSON.parse(res.data) as SwishPayerCertificateInfoResponse;
        }

        return res;
    }

    async GenerateCertificateCsr(postBody: SwishCertificateCsrBody) {
        const valuesToSend = new FormData();
        valuesToSend.append('organizationNumber', postBody.organizationNumber);
        valuesToSend.append('swishNumber', postBody.swishNumber);

        let res: AxiosResponse<Blob>;

        try {
            res = await Client('post', `${ENDPOINT.Swish.CertificateCsr()}`, valuesToSend, {
                responseType: 'blob'
            });
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async UploadCertificate(postBody: SwishCertificateUploadBody) {
        const valuesToSend = new FormData();
        valuesToSend.append('certificate', postBody.certificate);
        console.log(postBody.certificate);

        if (postBody.message) {
            valuesToSend.append('message', postBody.message);
        }

        let res: AxiosResponse;

        try {
            res = await Client('post', `${ENDPOINT.Swish.UploadCertificate()}`, valuesToSend);
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }
}

export default new SwishService();
